import type { Client, ClientLifecycleStatus, ClientSourceType } from '~/types/models';

export type ClientQuickCreateDraft = {
    companyName: string;
    contactName: string;
    email: string;
    phone: string;
    lifecycleStatus: ClientLifecycleStatus;
    source: ClientSourceType;
};

export function createClientQuickDraft(overrides: Partial<ClientQuickCreateDraft> = {}): ClientQuickCreateDraft {
    return {
        companyName: '',
        contactName: '',
        email: '',
        phone: '',
        lifecycleStatus: 'raw_enquiry',
        source: 'manual',
        ...overrides,
    };
}

export function canQuickCreateClient(draft: ClientQuickCreateDraft): boolean {
    return Boolean(draft.companyName.trim() || draft.contactName.trim());
}

export function buildQuickClientPayload(draft: ClientQuickCreateDraft): Omit<Client, 'id' | 'slug' | 'createdAt' | 'updatedAt'> {
    const companyName = draft.companyName.trim();
    const contactName = draft.contactName.trim();
    const email = draft.email.trim().toLowerCase();
    const phone = draft.phone.trim();
    const name = companyName || contactName;

    return {
        name,
        companyName,
        contactName,
        email,
        phone,
        contactNumber: phone,
        contacts: contactName || email || phone ? [{
            id: `contact_${Math.random().toString(36).slice(2, 10)}`,
            name: contactName || email.split('@')[0] || name,
            email,
            phone,
            isPrimary: true,
            projectAccessMode: 'all',
            projectIds: [],
        }] : [],
        lifecycle: {
            status: draft.lifecycleStatus,
            source: draft.source,
        },
    };
}
